import EntityFolder from './EntityFolder';

export default EntityFolder;
